<ngx-doc-viewer [url]="url_file"
    disableContent="popout-hide"
    viewer="google"
    class="preview-module">
</ngx-doc-viewer>